import { Box, Tooltip, Chip } from "@mui/joy";
import { Info as InfoIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { IconButton } from "../../../../shared";

/**
 * Info cell renderer - navigates to organization page.
 */
export function Info(props: any) {
    const navigate = useNavigate();
    const { value } = props;

    const handleClick = () => {
        navigate(`/admin/organizations/${value}`);
    };

    return (
        <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <Tooltip title="View details" placement="top">
                <IconButton
                    size="sm"
                    variant="soft"
                    color="primary"
                    onClick={handleClick}
                    sx={{
                        border: "1px solid",
                        borderColor: "divider",
                        "--IconButton-size": "32px",
                        borderRadius: "4px",
                    }}
                >
                    <InfoIcon size={16} />
                </IconButton>
            </Tooltip>
        </Box>
    );
}

/**
 * Status chip component with color coding
 */
export function StatusChip({ isActive }: { isActive: boolean }) {
    const config = isActive
        ? { color: "success" as const, label: "Active" }
        : { color: "neutral" as const, label: "Inactive" };

    return (
        <Chip
            variant="soft"
            color={config.color}
            size="md"
            sx={{
                borderRadius: "4px",
                border: "1px solid",
                borderColor: "divider",
            }}
        >
            {config.label}
        </Chip>
    );
}

/**
 * Status cell renderer
 */
export function StatusCellRenderer(props: any) {
    const { value } = props;
    const isActive = value === true || value === 1 || value === "1";
    return (
        <Box display="flex" alignItems="center" height="100%">
            <StatusChip isActive={isActive} />
        </Box>
    );
}
